import React from 'react';
import AdminHeader from './AdminHeader';
import './PlaceholderFeature.css';

const PlaceholderFeature = ({ title, description, icon, onBack }) => {
  return (
    <div className="admin-dashboard">
      <AdminHeader 
        title={title}
        onBack={onBack}
        showBackButton={true}
      />

      <main className="dashboard-main">
        <div className="breadcrumb">
          <span className="breadcrumb-item" onClick={onBack}>Admin Dashboard</span>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-item active">{title}</span>
        </div>

        <div className="placeholder-content">
          <div className="placeholder-icon">{icon}</div>
          <h2>Under Development</h2>
          <p>{description}</p>
          <div className="placeholder-info">
            <p>This feature is currently being developed and will be available soon.</p>
            <p>Check back later for updates!</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PlaceholderFeature;
